<template>
  <v-card
    class="zoox-component zoox-card"
    :class="{shadow: shadow || $zoox.cardShadow}"
    :width="width"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="title || $scopedSlots['actions'] || $scopedSlots['title']"
      class="card-title-container"
      :style="{
        'grid-template-columns': $scopedSlots['actions'] ? '1fr auto' : '1fr',
      }"
    >
      <!--@slot Slot para customização do título -->
      <slot name="title">
        <span
          class="card-title"
          :class="{
            start: justifyTitle === 'start',
            center: justifyTitle === 'center',
            end: justifyTitle === 'end',
          }"
        >
          {{ title }}
        </span>
      </slot>
      <div class="actions">
        <!--@slot Slot de ações do card -->
        <slot name="actions"></slot>
      </div>
    </div>
    <!--@slot Slot do conteúdo do card -->
    <slot name="content"></slot>
  </v-card>
</template>

<script>
/**
 * O Card é um componente importante. Boa parte do conteúdo exibido em tela é utilizado um card
 * para representar o container que o conteúdo é exibido. O título do card deve dar um contexto para o
 * conteúdo exibido.
 *
 * @displayName Card
 */
export default {
  name: 'ZCard',
  props: {
    /**
     * Título do Card.
     */
    title: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Alinhamento do título do card
     *
     * @typedef start,center,end
     */
    justifyTitle: {
      type: String,
      default: 'start',
    },
    /**
     * Largura do card
     */
    width: {
      type: [String, Number],
      required: false,
      default: 600,
    },
    /**
     * Flag para indicar que o card deve ter sombra
     */
    shadow: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-card {
  padding: var(--component-card-padding);
  box-shadow: none !important;
  border-radius: var(--component-card-radius) !important;

  &.shadow {
    box-shadow: var(--zoox-card-shadow) !important;
  }

  .card-title-container {
    display: grid;
    column-gap: 10px;

    .card-title {
      &.start {
        justify-self: start;
      }
      &.center {
        justify-self: center;
      }
      &.end {
        justify-self: flex-end;
      }
    }

    .actions {
      justify-self: flex-end;
    }
  }

  &::before {
    border-radius: var(--component-card-radius) !important;
  }
}
</style>
